module.exports = __webpack_public_path__ + "assets/82a72afbf66177ef2017e76bc8510c26.mp4";